module.exports = __webpack_public_path__ + "static/media/bolso (4).380e1d70.jpg";